<template>
  <v-card>
    <v-card-title>
      <v-icon left>
        vpn_key
      </v-icon>
      API Keys

      <v-spacer />

      <help-tooltip>
        API Keys allow 3rd party to access Atlas on your behalf
      </help-tooltip>
    </v-card-title>

    <v-list>
      <v-list-item
        v-for="(apiKey, i) in apiKeys"
        :key="apiKey.id.toString()"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ apiKey.name }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            text
            color="primary"
            @click="toggleApiKeyDisabled(apiKey)"
          >
            <v-icon left>
              {{ apiKey.disabled ? 'play' : 'pause' }}_circle_filled
            </v-icon>
            {{ apiKey.disabled ? 'Enable' : 'Disable' }}
          </v-btn>
        </v-list-item-action>

        <v-list-item-action>
          <v-btn
            icon
            color="error"
            @click="deleteApiKey(apiKey, i)"
          >
            <v-icon>delete_forever</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-alert
      v-if="apiKeys.length === 20"
      color="warning"
      icon="warning"
      text
      dense
      prominent
    >
      You can't create more than 20 API Keys, if you need more,
      please delete existing ones.
    </v-alert>

    <v-divider />

    <v-card-actions>
      <api-key-create-dialog
        :disabled="apiKeys.length === 20"
        @created="onApiKeyCreated"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { UserApiKeyAuthProviderClient } from 'mongodb-stitch-browser-sdk'
import { client } from '@/plugins/stitch'

import ApiKeyCreateDialog from './ApiKeyCreateDialog'

export default {
  name: 'ApiKeyManager',
  components: {
    ApiKeyCreateDialog
  },
  data () {
    return {
      apiKeyClient: null,
      apiKeys: []
    }
  },
  async mounted () {
    this.apiKeyClient = client.auth
      .getProviderClient(UserApiKeyAuthProviderClient.factory)

    this.apiKeys = await this.apiKeyClient.fetchApiKeys()
  },
  methods: {
    async toggleApiKeyDisabled (apiKey) {
      if (apiKey.disabled) {
        await this.apiKeyClient.enableApiKey(apiKey.id)
      } else {
        await this.apiKeyClient.disableApiKey(apiKey.id)
      }

      // if no error, update disabled prop
      apiKey.disabled = !apiKey.disabled
      this.$notify(`API Key ${apiKey.name} has been ${apiKey.disabled ? 'disabled' : 'enabled'}`)
    },
    async deleteApiKey (apiKey, i) {
      await this.apiKeyClient.deleteApiKey(apiKey.id)
      this.apiKeys.splice(i, 1)
      this.$notify(`API Key ${apiKey.name} has been deleted`)
    },
    onApiKeyCreated (apiKey) {
      this.apiKeys.push(apiKey)
    }
  }
}
</script>

<style>

</style>
